// Versionslogik fuer „Was ist neu“ (Katalog-Release K5); rein, ohne Browser.

/** Numeric SemVer comparison; invalid versions sort first. */
export function compareVersions(left, right) {
  const parse = value => (/^\d+\.\d+\.\d+$/.test(String(value || '')) ? String(value).split('.').map(Number) : [-1, -1, -1]);
  const a = parse(left);
  const b = parse(right);
  for (let index = 0; index < 3; index += 1) if (a[index] !== b[index]) return a[index] - b[index];
  return 0;
}

/** The API lists published releases newest first; never fall back to older notes. */
export function currentReleaseVersions(versions) {
  return Array.isArray(versions) ? versions.slice(0, 1) : [];
}

/** Show only the current release, and only if it has not been acknowledged. */
export function unseenVersions(versions, seen) {
  return currentReleaseVersions(versions).filter(entry => !seen || compareVersions(entry.version, seen) > 0);
}
